/**
 * Request Tracker Module
 * 
 * This module provides functionality to track and prevent duplicate requests
 * by maintaining a temporary cache of recently sent requests.
 */

// Map to store recent requests
const duplicateRequestTracker = new Map();

/**
 * Checks if a request is a duplicate of one recently sent
 * 
 * @param {string} event - The event name
 * @param {object} data - The data payload
 * @param {number} timeout - Time in milliseconds before a request is no longer considered a duplicate (default: 1000ms)
 * @returns {boolean} - True if the request is a duplicate, false otherwise
 */
export const isDuplicateRequest = (event, data, timeout = 1000) => {
  const requestKey = JSON.stringify({ event, data });
  
  // Check if this request was recently sent
  if (duplicateRequestTracker.has(requestKey)) {
    return true;
  }
  
  // Add this request to the tracker
  duplicateRequestTracker.set(requestKey, true);
  
  // Set a timeout to remove this request from the tracker
  setTimeout(() => {
    duplicateRequestTracker.delete(requestKey);
  }, timeout);
  
  return false;
};

/**
 * Clears all tracked requests
 */
export const clearRequestTracker = () => {
  duplicateRequestTracker.clear();
};

/**
 * Gets the current number of tracked requests
 * 
 * @returns {number} - The number of tracked requests
 */
export const getTrackedRequestCount = () => {
  return duplicateRequestTracker.size;
}; 